import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/retenedores-cedulares/';

/**
 * GET Retenedor De Cedula
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRetenedoresDeCedulas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Retenedor De Cedula
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getRetenedorCedula = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Retenedor De Cedula
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postRetenedorDeCedula = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Retenedor De Cedula
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchRetenedorDeCedula = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Retenedor De Cedula
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteRetenedorDeCedula = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Retenedor De Cedula
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosRetenedorDeCedula = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Retenedor De Cedula Caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRetenedorDeCedulaCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/retenedor-cedular-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
